import React, { useMemo } from 'react'
import dayjs from 'dayjs'

interface DateFormatProps {
  date?: string | Date | null // Optional date property
  format?: string // Optional format for dates that are neither today nor tomorrow
}

export const DateFormat: React.FC<DateFormatProps> = ({
  date,
  format = 'DD/MM/YYYY',
}) => {
  const inputDate = useMemo(() => dayjs(date), [date])

  const displayDate = useMemo(() => {
    if (!date) return null // Return null if no date is provided

    return inputDate.format(format) // Use the passed format for other dates
  }, [date, format, inputDate])

  // If no date or displayDate is null, render nothing
  if (!displayDate) return null

  return <>{displayDate}</>
}
